import styled from "styled-components";
import { CommentInputBox } from "../CommentsSectionStyled";

export const EditingCommentInput = styled(CommentInputBox)`
  height: 8rem;
  padding-bottom: 4.8rem;
  text-wrap: wrap;
`;
